import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { I as IconButton } from '../IconButton/IconButton-Copc-LdF.js';
import { g as getTranslationComponent } from '../../i18n/CloseButtonTranslation/index-A6SlLYFV.js';
import { i as invertedFocusOutline } from '../../theme/style-mixins/FocusIndicator/invertedFocusOutline-BxN_kWq6.js';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { u as useSurface } from '../../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';
import { I as IntlProvider } from '../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { h as close } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StyledIconButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-hg0t2u-0"
})(["cursor:pointer;&&&{background-color:transparent;color:", ";:hover{background-color:transparent;color:", ";}:active{background-color:transparent;color:", ";}:focus-visible{", ";}:disabled{color:", ";}}"], ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.inverted : theme.icon.color.tertiary, ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.invertedHover : theme.icon.color.tertiaryHover, ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.invertedActive : theme.icon.color.tertiaryActive, ({
  $inverted
}) => $inverted ? invertedFocusOutline : focusOutline, ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.invertedUnavailable : theme.icon.color.unavailable);
const CloseIconButton = ({
  inverted = false,
  onClick,
  label,
  size = 'small',
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(StyledIconButton, _extends({}, rest, {
    icon: close,
    onClick: onClick,
    small: size === 'small',
    label: label || formatMessage({
      id: 'close_button_label'
    }),
    "aria-label": label || formatMessage({
      id: 'close_button_label'
    }),
    variant: "transparent",
    $inverted: inverted
  }));
};
const CloseButton = /*#__PURE__*/forwardRef(({
  fallback,
  inverted = false,
  locale = 'en-US',
  onClick = noop,
  onError,
  onReset,
  size = 'base',
  taktId,
  taktValue,
  ...rest
}, ref) => {
  const translations = getTranslationComponent(locale);
  const {
    isInverted: surfaceIsInverted
  } = useSurface();
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    onError: onError,
    resetKey: locale,
    fallback: fallback,
    onReset: onReset,
    translations: translations
  }, /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('close-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(CloseIconButton, _extends({}, getDataTaktAttributes(), rest, {
    inverted: surfaceIsInverted || inverted,
    onClick: onClick,
    size: size,
    buttonRef: ref
  }))));
});
CloseButton.displayName = 'CloseButton';

export { CloseButton as C };
//# sourceMappingURL=CloseButton-cLZyFeIM.js.map
